/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Generating_WaveformInputs */

const en_timeline_generating_waveform = /** @type {(inputs: Timeline_Generating_WaveformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating Waveform...`)
};

const fr_timeline_generating_waveform = /** @type {(inputs: Timeline_Generating_WaveformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generation de la forme d'onde...`)
};

const de_timeline_generating_waveform = /** @type {(inputs: Timeline_Generating_WaveformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wellenformerzeugung...`)
};

const it_timeline_generating_waveform = /** @type {(inputs: Timeline_Generating_WaveformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generazione della forma d'onda...`)
};

const ru_timeline_generating_waveform = /** @type {(inputs: Timeline_Generating_WaveformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Генерация волновой формы...`)
};

const es_timeline_generating_waveform = /** @type {(inputs: Timeline_Generating_WaveformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generando forma de onda...`)
};

const zh_cn2_timeline_generating_waveform = /** @type {(inputs: Timeline_Generating_WaveformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成波形...`)
};

const ja_timeline_generating_waveform = /** @type {(inputs: Timeline_Generating_WaveformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`波形を生成しています...`)
};

const hi_timeline_generating_waveform = /** @type {(inputs: Timeline_Generating_WaveformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वेवफॉर्म जनरेट हो रहा है...`)
};

const pt_pt2_timeline_generating_waveform = /** @type {(inputs: Timeline_Generating_WaveformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerando forma de onda...`)
};

/**
* | output |
* | --- |
* | "Generating Waveform..." |
*
* @param {Timeline_Generating_WaveformInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_generating_waveform = /** @type {((inputs?: Timeline_Generating_WaveformInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Generating_WaveformInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timeline_generating_waveform(inputs)
	if (locale === "de") return de_timeline_generating_waveform(inputs)
	if (locale === "it") return it_timeline_generating_waveform(inputs)
	if (locale === "ru") return ru_timeline_generating_waveform(inputs)
	if (locale === "es") return es_timeline_generating_waveform(inputs)
	if (locale === "zh-CN") return zh_cn2_timeline_generating_waveform(inputs)
	if (locale === "ja") return ja_timeline_generating_waveform(inputs)
	if (locale === "hi") return hi_timeline_generating_waveform(inputs)
	if (locale === "pt-PT") return pt_pt2_timeline_generating_waveform(inputs)
	return en_timeline_generating_waveform(inputs)
});